import { render, staticRenderFns } from "./company-detail.vue?vue&type=template&id=6d976ce6&"
import script from "./company-detail.vue?vue&type=script&lang=js&"
export * from "./company-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports